import PropTypes from 'prop-types';

import { colors } from 'styles/theme';

/**
 * @param {object} props
 */
function VelieveLogo({
  width = '100%',
  height = '100%',
  viewBox = '0 0 159 42',
  color = colors.darkPurple,
  className = '',
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
    >
      <defs>
        <path d="M.093.039h16.532v17.02H.093z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M65.416 32.701c-.557 0-1.035-.32-1.246-.836l-6.104-14.873a1.035 1.035 0 0 1 .959-1.43c.424 0 .8.254.96.646l5.431 13.376 5.431-13.376a1.035 1.035 0 1 1 1.919.783l-6.104 14.874c-.211.516-.689.836-1.246.836"
        />
        <path
          fill={color}
          d="M71.807 15.548c-.427 0-.812.26-.973.655l-5.418 13.344-5.418-13.344a1.05 1.05 0 1 0-1.945.794l6.104 14.874c.23.562.745.844 1.26.844.513 0 1.027-.282 1.258-.844l6.104-14.874a1.05 1.05 0 0 0-.972-1.45m0 .029a1.02 1.02 0 0 1 .946 1.41L66.649 31.86c-.21.51-.682.827-1.233.827a1.312 1.312 0 0 1-1.233-.827l-6.104-14.874a1.02 1.02 0 0 1 .946-1.41c.418 0 .79.25.947.638l5.418 13.343.026.064.026-.064 5.418-13.343c.157-.388.53-.638.947-.638M132.557 32.722c-.566 0-1.051-.325-1.266-.849L125.187 17a1.056 1.056 0 0 1 .978-1.46c.433 0 .818.26.98.66l5.418 13.344 5.405-13.343a1.056 1.056 0 1 1 1.958.8l-6.104 14.872c-.214.524-.7.849-1.265.849"
        />
        <path
          fill={color}
          d="M138.948 15.534c-.435 0-.823.26-.986.664l-5.405 13.312-5.405-13.312a1.063 1.063 0 1 0-1.971.804l6.104 14.874c.215.526.703.853 1.272.853.568 0 1.056-.327 1.272-.853l6.104-14.874a1.062 1.062 0 0 0-.985-1.468m0 .014c.747 0 1.255.758.972 1.45l-6.104 14.873a1.341 1.341 0 0 1-1.26.844 1.341 1.341 0 0 1-1.258-.844l-6.104-14.874a1.05 1.05 0 0 1 1.945-.794l5.418 13.344 5.418-13.344a1.05 1.05 0 0 1 .973-.655M76.722 22.661h12.114c-.454-3.573-3.052-5.424-5.846-5.424-3.41 0-5.846 2.241-6.268 5.424m14.323 1.072v.01a1.013 1.013 0 0 1-1.02.997H76.722c.454 3.313 3.02 5.36 6.463 5.36 2.145 0 3.745-.84 4.725-2.027.332-.402.91-.497 1.36-.233.575.337.716 1.119.276 1.62-1.444 1.646-3.645 2.718-6.393 2.718-5.133 0-8.64-3.605-8.64-8.51 0-4.775 3.443-8.51 8.477-8.51 4.97 0 8.055 4.125 8.055 8.575M96.764 9.15v21.566a1.072 1.072 0 1 1-2.144 0V9.15a1.072 1.072 0 1 1 2.144 0zM102.305 15.548c.592 0 1.072.48 1.072 1.072v14.096a1.072 1.072 0 1 1-2.144 0V16.62c0-.592.48-1.072 1.072-1.072m-1.56-5.002a1.56 1.56 0 1 1 3.12 0 1.56 1.56 0 0 1-3.12 0M109.323 22.661h12.115c-.455-3.573-3.053-5.424-5.847-5.424-3.41 0-5.846 2.241-6.268 5.424m14.324 1.072v.01a1.013 1.013 0 0 1-1.02.997h-13.304c.455 3.313 3.02 5.36 6.463 5.36 2.145 0 3.745-.84 4.725-2.027.332-.402.91-.497 1.36-.233.575.337.716 1.119.277 1.62-1.444 1.646-3.646 2.718-6.394 2.718-5.132 0-8.64-3.605-8.64-8.51 0-4.775 3.443-8.51 8.477-8.51 4.97 0 8.056 4.125 8.056 8.575"
        />
        <g transform="translate(141.44 15.12)">
          <mask fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill={color}
            d="M2.302 7.542h12.115c-.455-3.573-3.053-5.425-5.847-5.425-3.41 0-5.846 2.242-6.268 5.425m14.323 1.072v.01a1.013 1.013 0 0 1-1.02.996H2.303c.454 3.313 3.02 5.36 6.463 5.36 2.145 0 3.745-.84 4.725-2.026.332-.403.91-.497 1.36-.234.575.337.716 1.119.276 1.62-1.444 1.647-3.645 2.718-6.393 2.718-5.132 0-8.64-3.605-8.64-8.51 0-4.774 3.443-8.51 8.477-8.51 4.97 0 8.055 4.126 8.055 8.576"
            mask="url(#b)"
          />
        </g>
        <path
          stroke={color}
          strokeWidth="2.38"
          d="M15.228 37.241c-4.385-4.385-4.385-11.494 0-15.878l7.934-7.935-1.925-1.924c-4.385-4.385-11.494-4.385-15.878 0-4.385 4.385-4.385 11.494 0 15.879l9.858 9.858a11.192 11.192 0 0 0 7.945 3.289 11.193 11.193 0 0 1-7.934-3.289zM47.11 5.359c-4.385-4.385-11.494-4.385-15.878 0l-8.07 8.07 7.934 7.933c4.384 4.385 4.384 11.494 0 15.879a11.192 11.192 0 0 1-7.934 3.289 11.193 11.193 0 0 0 7.944-3.289L47.11 21.237c4.385-4.385 4.385-11.494 0-15.878z"
        />
        <path
          stroke={color}
          strokeWidth="2.38"
          d="M31.096 37.241c4.384-4.385 4.384-11.494 0-15.878l-7.934-7.935-7.935 7.935c-4.384 4.384-4.384 11.493 0 15.878a11.193 11.193 0 0 0 7.935 3.289 11.193 11.193 0 0 0 7.934-3.289z"
        />
      </g>
    </svg>
  );
}

VelieveLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default VelieveLogo;
